import React, { useState } from 'react'
import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper'
import { useStyles } from './RouteApp.styles'
import { WithErrorBoundary } from '../WithErrorBoundary'

interface RouteAppProps extends Partial<ReactChildrenProps> {
  title?: string
  titleIcon?: React.ReactNode
  actions?: React.FC
  component?: React.FC
  hideTitle?: boolean
  withOpenSidePanel?: boolean
}

export const RouteApp: React.FC<RouteAppProps> = ({
  title,
  actions: Actions,
  component: Component,
  children,
  titleIcon,
  hideTitle,
  withOpenSidePanel,
}) => {
  const { classes } = useStyles()
  const [pageYOffset, setPageYOffset] = useState(0)
  const onScrollValue = (pageYOffsetValue: number) => {
    setPageYOffset(pageYOffsetValue)
  }
  return (
    <div
      className={`${
        withOpenSidePanel
          ? classes.withOpenSidePanel
          : classes.withRegularSidePanel
      } ${classes.root}`}
    >
      <div
        className={classes.content}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onScroll={(e: any) => onScrollValue(e.target.scrollTop)}
      >
        <HeaderWrapper
          title={title}
          titleIcon={titleIcon}
          actions={Actions}
          pageYOffset={pageYOffset}
          hideTitle={hideTitle}
        />

        <div data-testid="app-body" className={classes.appBody}>
          {Component ? (
            <WithErrorBoundary boundary="RouteApp">
              <Component />
            </WithErrorBoundary>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  )
}
